import { render, staticRenderFns } from "./PcScrollingPrompts.vue?vue&type=template&id=3bd756f4"
import script from "./PcScrollingPrompts.vue?vue&type=script&lang=js"
export * from "./PcScrollingPrompts.vue?vue&type=script&lang=js"
import style0 from "./PcScrollingPrompts.vue?vue&type=style&index=0&id=3bd756f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports